import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { dynatraceUtil } from '@uhg-uhcpp-sde-core/monstera-utility';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'DELETE_SECRET_API';

export const resetDeleteSecretAPI = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });
  const action = useAction(() => {
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
    };
  });
  return [result, action];
};

const getAction = () => {
  const action = useAction((args) => {
    const eapm = window.elasticApm;
    let dtrumActionId;
    if (eapm) {
      window.elasticApm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: true,
      });
    }
    const { orgId, clientId, keyId, isProd } = args;
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      dtrumActionId = dynatraceUtil.startAction(ACTION_TYPE, `${config('APIM_STARGATE_URL')}${config('CREDENTIALS_URL')}?q=${ACTION_TYPE}`);
      fetch(`${config('APIM_STARGATE_URL')}${config('CREDENTIALS_URL')}`, {
        credentials: 'include',
        method: 'delete',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          orgId: orgId,
          clientId: clientId,
          keyId: keyId,
          isProd: isProd,
        }),
      })
        .then((res) => {
          if (res?.status) {
            return new Promise((resolve) => {
              return setTimeout(resolve, 2000);
            }).then(() => {
              dispatch({ type: `${ACTION_TYPE}_COMPLETED` });
            });
          } else {
            dispatch({
              type: `${ACTION_TYPE}_ERROR`,
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });
          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('CREDENTIALS_URL'),
              userInfo: args?.userInfo,
              method: 'DELETE',
              operationName: ACTION_TYPE,
              // code: res.status,
              // message: res.statusText,
            },
          });

          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('CREDENTIALS_URL'),
            status: 0,
            message: 'Error',
            url: window.location.href,
            result: 'error',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });
        });
    };
  });
  return action;
};
export const useDeleteSecretAPI = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });
  const action = getAction();

  return [result, action];
};
